module.exports = __webpack_public_path__ + "1af5f81a3df51c24c887f7cff55e7371.svg";